/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Mini_S1Inputs */

const en_tut_mini_s1 = /** @type {(inputs: Tut_Mini_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In the office header, press **Mini Mode**. A small window opens with your status, the people list, and remaining focus time — no map.`)
};

const id_tut_mini_s1 = /** @type {(inputs: Tut_Mini_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Di header kantor, tekan **Mini Mode**. Jendela kecil terbuka berisi status Anda, daftar rekan, dan sisa waktu fokus — tanpa peta.`)
};

/**
* | output |
* | --- |
* | "In the office header, press **Mini Mode**. A small window opens with your status, the people list, and remaining focus time — no map." |
*
* @param {Tut_Mini_S1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_mini_s1 = /** @type {((inputs?: Tut_Mini_S1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Mini_S1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_mini_s1(inputs)
	return en_tut_mini_s1(inputs)
});